"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsultationController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const consultation_service_1 = require("./consultation.service");
const appointment_entity_1 = require("./appointment.entity");
const notification_log_entity_1 = require("../notifications/notification-log.entity");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
let ConsultationController = class ConsultationController {
    constructor(consultationService) {
        this.consultationService = consultationService;
    }
    findAll(customerId, doctorId, status) {
        return this.consultationService.findAll(customerId ? parseInt(customerId, 10) : undefined, doctorId ? parseInt(doctorId, 10) : undefined, status);
    }
    findOne(id) {
        return this.consultationService.findByIdDetail(id);
    }
    create(body, user) {
        return this.consultationService.create({
            ...body,
            scheduledAt: new Date(body.scheduledAt),
            channels: (body.channels ?? [])
                .map(channel => `${channel}`.toLowerCase())
                .filter((channel) => Object.values(notification_log_entity_1.NotificationChannel).includes(channel)),
            bookedByAgentId: user.id,
        });
    }
    reschedule(id, body, user) {
        return this.consultationService.reschedule(id, new Date(body.scheduledAt), user.id);
    }
    cancel(id, body) {
        return this.consultationService.updateStatus(id, appointment_entity_1.AppointmentStatus.CANCELLED, body.reason);
    }
    addDoctorNotes(id, body, user) {
        return this.consultationService.addDoctorNotes(id, body.notes, user.id);
    }
    markWalkIn(id) {
        return this.consultationService.markWalkIn(id);
    }
    markPaymentReceived(id, body) {
        return this.consultationService.markPaymentReceived(id, body.paymentReference);
    }
    close(id, body, user) {
        return this.consultationService.closeConsultation(id, body, user.id);
    }
};
exports.ConsultationController = ConsultationController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_READ),
    tslib_1.__param(0, (0, common_1.Query)('customerId')),
    tslib_1.__param(1, (0, common_1.Query)('doctorId')),
    tslib_1.__param(2, (0, common_1.Query)('status')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, typeof (_b = typeof appointment_entity_1.AppointmentStatus !== "undefined" && appointment_entity_1.AppointmentStatus) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], ConsultationController.prototype, "findAll", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], ConsultationController.prototype, "findOne", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_e = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _e : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], ConsultationController.prototype, "create", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/reschedule'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_RESCHEDULE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_f = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _f : Object]),
    tslib_1.__metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], ConsultationController.prototype, "reschedule", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/cancel'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_CANCEL),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
], ConsultationController.prototype, "cancel", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/doctor-notes'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_ADD_DOCTOR_NOTES),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_j = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _j : Object]),
    tslib_1.__metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
], ConsultationController.prototype, "addDoctorNotes", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/walk-in'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_MARK_WALK_IN),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
], ConsultationController.prototype, "markWalkIn", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/payment-received'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_CREATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
], ConsultationController.prototype, "markPaymentReceived", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/close'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CONSULTATIONS_CLOSE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_o = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _o : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], ConsultationController.prototype, "close", null);
exports.ConsultationController = ConsultationController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('consultations'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof consultation_service_1.ConsultationService !== "undefined" && consultation_service_1.ConsultationService) === "function" ? _a : Object])
], ConsultationController);
